import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { twMerge } from 'tailwind-merge'

interface ContentSkeletonProps {
  className?: string
}

export const ContentSkeleton = ({ className }: ContentSkeletonProps) => {
  return (
    <main className={twMerge('relative', className)}>
      <div className="m-auto w-[50%]">
        <div className="mb-5 flex justify-between">
          <div className="w-[29%]">
            <Skeleton height={50} />
          </div>
          <div className="w-[70%]">
            <Skeleton height={50} />
          </div>
        </div>
        <Skeleton count={4} />
      </div>
    </main>
  )
}
